import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputIconToggleComponent } from './input-icon-toggle.component';

@NgModule({
  imports: [CommonModule],
  declarations: [InputIconToggleComponent],
  exports: [InputIconToggleComponent]
})
export class InputIconToggleModule {}
